var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopularIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3339_13270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.6875 14L4.25523 10.1823L0.4375 8.75L4.25523 7.31773L5.6875 3.5L7.11977 7.31773L10.9375 8.75L7.11977 10.1823L5.6875 14Z",
    fill: "#54EF9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.40625 4.8125L1.76176 3.05074L0 2.40625L1.76176 1.76176L2.40625 0L3.05074 1.76176L4.8125 2.40625L3.05074 3.05074L2.40625 4.8125Z",
    fill: "#54EF9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 7L10.0868 4.78816L7.875 3.9375L10.0868 3.08684L10.9375 0.875L11.7882 3.08684L14 3.9375L11.7882 4.78816L10.9375 7Z",
    fill: "#54EF9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3339_13270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopularIcon);
export default __webpack_public_path__ + "static/media/popularIcon.b90b579f3ad545ac1bdae9bda072233b.svg";
export { ForwardRef as ReactComponent };